import CreateOrderCheckoutError from './CreateOrderCheckoutError.js'
import GetPaymentMethodsCheckoutError from './GetPaymentMethodsCheckoutError.js'
import OrderCheckoutError from './OrderCheckoutError.js'
import PurchaseCheckoutError from './PurchaseCheckoutError.js'
import PurchaseDetailsCheckoutError from './PurchaseDetailsCheckoutError.js'

export default class CheckoutErrorsFactory {
  static getPaymentMethodsCheckoutError = () => new GetPaymentMethodsCheckoutError()

  static purchaseCheckoutError = () => new PurchaseCheckoutError()

  static purchaseDetailsCheckoutError = () => new PurchaseDetailsCheckoutError()

  static createOrderCheckoutError = () => new CreateOrderCheckoutError()

  static orderCheckoutError = () => new OrderCheckoutError()
}
